export enum ApiKeyRole {
  Read = "read",
  Write = "write",
}

export interface ApiKey {
  id: string;
  name: string;
  keyPrefix: string;
  role: ApiKeyRole;
  createdAt: string;
  lastUsedAt?: string;
  revokedAt?: string;
}

// Returned only by createApiKey — carries the one-time plaintext secret.
export interface CreatedApiKey {
  id: string;
  name: string;
  keyPrefix: string;
  role: ApiKeyRole;
  key: string;
}
